import { Directive, ElementRef, Renderer2, Input, PLATFORM_ID, Inject, OnInit, DestroyRef } from '@angular/core';
import { isPlatformBrowser, Location } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent } from 'rxjs';

/**
 * Scroll Navigation directive.
 */
@Directive({
    selector: '[appScrollNav]',
    standalone: false
})
export class ScrollNavDirective implements OnInit {
  @Input() nav: HTMLElement;

  constructor(
    private element: ElementRef<HTMLHeadElement>, 
    private renderer: Renderer2, 
    private location: Location,
    private destoryRef: DestroyRef,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      fromEvent(window, 'scroll')
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe(() => this.headerScrolled());
    }
  }

  /**
   * Scrolls top navigation.
   */
  public headerScrolled(): void {
    window.scrollY > 50
      ? this.renderer.addClass(this.host, 'scrolled')
      : this.renderer.removeClass(this.host, 'scrolled');

    this.location.path() === '/home' && window.scrollY <= 50
      ? this.renderer.addClass(this.nav, 'home')
      : this.renderer.removeClass(this.nav, 'home');
  }

  /**
   * Getter for easy access to the host element.
   */
  private get host() {
    return this.element.nativeElement;
  }
}
